export default function SurveyKeyDownController(view, model) {
  return evt => {
    if (evt.repeat) return;
    if (model.surveyDone) {
      model.deferred.resolve();
      return;
    }
    console.log(evt.keyCode);
    switch (evt.keyCode) {
      case 13:
        // RETURN
        view.submit();
        break;
      case 37:
      case 38:
      case 87: // Up
      case 65:
        // Left
        view.selectPrevAnswer();
        break;
      case 39:
      case 40:
      case 83: // Down
      case 68:
        // Right
        view.selectNextAnswer();
        break;
      case 27:
        // Esc
        view.cancel();
        break;
    }
  };
}